import { render, staticRenderFns } from "./CorrectiveFilter.vue?vue&type=template&id=df2585a0&"
import script from "./CorrectiveFilter.vue?vue&type=script&lang=js&"
export * from "./CorrectiveFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports